

























































import { Component, Prop, Vue } from 'vue-property-decorator';
import AlpacaBtn from '@/components/AlpacaBtn.vue';
import { Alpaca } from '@/backend/type';
import { payment, feed } from '@/contract/alpacaGrass';
import { userETHBalance } from '@/utils/web3';
import BigNumber from 'bignumber.js';

@Component({
  components: {
    AlpacaBtn,
  },
})
export default class Boost extends Vue {
  @Prop({
    required: true,
  })
  public alpaca!: Alpaca;

  public showBoost: boolean = false;
  public ethBalance: BigNumber = new BigNumber(0);
  public bulls = [
    {
      title: 'Green',
      range: '0-200',
      price: new BigNumber(0),
    },
    {
      title: 'Blue',
      range: '0-550',
      price: new BigNumber(0),
    },
    {
      title: 'Red',
      range: '0-2200',
      price: new BigNumber(0),
    },
  ];

  get account() {
    return this.$store.getters.getAccount;
  }

  get canBoost() {
    return this.alpaca && Number(this.alpaca.total_energy) < 8000;
  }

  public mounted() {
    this.userETHBalance();
    this.bulls.forEach((bull, index) => {
      this.getPrice(index);
    });
  }

  public async getPrice(pid: number) {
    const amount = await payment(pid);
    if (amount) {
      this.bulls[pid].price = new BigNumber(amount);
    }
  }

  public async userETHBalance() {
    const amount = await userETHBalance(this.account);
    if (amount) {
      return this.ethBalance = new BigNumber(amount);
    }
  }

  public handleFeed(pid: number) {
    feed(pid, this.bulls[pid].price, this.account, this.alpaca.shepherd, this.alpaca.id);
  }

  public isDisabled(pid: number) {
    return this.ethBalance.isLessThan(this.bulls[pid].price);
  }
}
